import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Pythonsidebar';

import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";

function Pfunctionoverload(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
     <div>
<Sides/>
<Helmet>
 
  <title>Learn Free Python Function overloading Beginners Tutorials CodeExampler</title>
<meta name="description" content="Python function overloading tutorial for beginners and Python Function overloading use overload another function" />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,function overloading in python example,function overloading in python using class,python function overloading by type,function overloading in python with example,python overload function decorator" />
<link rel="canonical" href="https://www.codeexampler.com/python-function-overloading" />
</Helmet>

<div className='lg:pl-56'>


    <h1 className="m-4 mh1">Python Function overloading</h1>

    <div className="first">
        <a href="/python-function-argument">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-function-overriding">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>



<h2 className='headings'>Function Overloading in Python Example</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty">def </span>
                 <span className="qwerty-8">fun</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">x</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
                 {"\n"}
                 <span className="qwerty-3">    print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">x</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty">def </span>
                 <span className="qwerty-8">fun</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">x</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
                 {"\n"}
                 <span className="qwerty-3">    print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">x</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-4">x</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-8">fun</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-10">20</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-8">fun</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-10">40</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"500vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty-2">40</span>
                     {"\n"}
                         <span className="qwerty-2">80</span>
                         {"\n"}      {"\n"}      
               </code>
                 </pre>
                 </div>




<h2 className='headings'>Function Overloading in Python Example</h2>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
       <pre style={{maxHeight:"500vh"}}>
           <code >
             {"\n"}
                 <span className="qwerty">def </span>
                 <span className="qwerty-8">fun</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">x</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
                 {"\n"}
                 <span className="qwerty-3">    print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">x</span>
                 <span className="qwerty-1">)</span>
             {"\n"}
                 <span className="qwerty">def </span>
                 <span className="qwerty-8">fun</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">x</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
                 {"\n"}
                 <span className="qwerty-3">    print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">x</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-4">x</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-8">fun</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-10">10</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-8">fun</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-10">20</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty">def </span>
                 <span className="qwerty-8">fun</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">x</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-4">y</span>
                 <span className="qwerty-1">)</span>
                 <span className="qwerty-1">:</span>
                 {"\n"}
                 <span className="qwerty-3">    print</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-4">x</span>
                 <span className="qwerty">+</span>
                 <span className="qwerty-4">y</span>
                 <span className="qwerty-1">)</span>
                 {"\n"}
                 <span className="qwerty-8">fun</span>
                 <span className="qwerty-1">(</span>
                 <span className="qwerty-10">20</span>
                 <span className="qwerty-1">,</span>
                 <span className="qwerty-10">40</span>
                 <span className="qwerty-1">)</span>
             {"\n"}{"\n"}
                  </code>
         </pre>
         </div>          
         <h5 className='headings'> Output : </h5>
          <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
             <pre style={{maxHeight:"500vh"}}>
                 <code >
                     {"\n"}
                         <span className="qwerty-2">20</span>
                     {"\n"}
                         <span className="qwerty-2">40</span>
                     {"\n"}
                         <span className="qwerty-2">60</span>
                         {"\n"}      {"\n"}      
               </code>
                 </pre>
                 </div>


  <h1 className="mt-5">  </h1>
     
  <div className="back">
        <a href="/python-function-argument">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/python-function-overriding">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div> </div>
)

}
export default Pfunctionoverload;